import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

interface WarningDialogComponentData {
	title: string;
	message: string;
	warning: string;
	cancelCTA?: string;
	successCTA?: string;
	hideCloseIcon?: boolean;
}

@Component({
	selector: 'amd-warning-dialog',
	templateUrl: './warning-dialog.component.html',
	styleUrls: ['./warning-dialog.component.scss'],
	providers: [TranslatePipe]
})
export class WarningDialogComponent {

	title: string;
	message: string;
	warning: string;
	cancelCTA: string;
	successCTA: string;
	hideCloseIcon: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA) 
		public data: WarningDialogComponentData,
		public dialogRef: MatDialogRef<WarningDialogComponent>,
		public translatePipe: TranslatePipe
	) {
		this.title = data.title;
		this.message = data.message;
		this.warning = data.warning;
		this.cancelCTA = data.cancelCTA || this.translatePipe.transform('ANNULLA');
		this.successCTA = data.successCTA || this.translatePipe.transform('CONTINUA');
		this.hideCloseIcon = !!data.hideCloseIcon;
	}

}
